/* 
fiky-web
*/

import React, { useState, useEffect } from "react";

import Helmet from "../components/Helmet/Helmet.js";
import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";

import heroImg from "../assets/images/10.png";
import "../styles/hero-section.css";

import { Link } from "react-router-dom";

import "../styles/home.css";

import products from "../assets/fake-data/products.js";

import foodCategoryImg01 from "../assets/images/makanan.jpg";
import foodCategoryImg02 from "../assets/images/minuman.png";
import foodCategoryImg03 from "../assets/images/bread.png";

import ProductCard from "../components/UI/product-card/ProductCard.jsx";

import networkImg from "../assets/images/network.png";

import TestimonialSlider from "../components/UI/slider/TestimonialSlider.jsx";

const Home = () => {
  const [category, setCategory] = useState("ALL");
  const [allProducts, setAllProducts] = useState(products);

  const [hotPizza, setHotPizza] = useState([]);

  useEffect(() => {
    const filteredPizza = products.filter((item) => item.category === "Pizza");
    const slicePizza = filteredPizza.slice(0, 4);
    setHotPizza(slicePizza);
  }, []);

  useEffect(() => {
    if (category === "ALL") {
      setAllProducts(products);
    }

    if (category === "FOOD") {
      const filteredProducts = products.filter(
        (item) => item.category === "Food"
      );

      setAllProducts(filteredProducts);
    }

    if (category === "DRINK") {
      const filteredProducts = products.filter(
        (item) => item.category === "Drink"
      );

      setAllProducts(filteredProducts);
    }

    if (category === "SNACK") {
      const filteredProducts = products.filter(
        (item) => item.category === "Snack"
      );

      setAllProducts(filteredProducts);
    }
  }, [category]);

  return (
    <Helmet title="Home">
      <section>
        <Container>
          <Row>
            <Col lg="6" md="6">
              <div className="hero__content  ">
                <h5 className="mb-3">Cara Mudah Untuk Pesan Makanan</h5>
                <h1 className="mb-4 hero__title">
                  <span>Kamu Lapar?</span> Tunggu Saja <br /> Makananmu Sampai
                  <span> Di Depan Pintumu</span>
                </h1>

                <p>
                  Layanan Pemesanan Makanan Untuk Anak Kost Al-muhayyat. Pembayaran: Cash On Delivery (COD).
                </p>

                <div className="hero__btns d-flex align-items-center gap-5 mt-4">
                  <button className="order__btn d-flex align-items-center justify-content-between">
                  <Link to="/foods">Pesan Sekarang <i class="ri-arrow-down-s-line"></i></Link>
                  </button>

                  <button className="all__foods-btn">
                    <a href="https://drive.google.com/file/d/1tttbIJhdOCGPzzly5UBV5v1t2wB3USme/view?usp=sharing">User Manual Video</a>
                  </button>
                </div>

                <div className=" hero__service  d-flex align-items-center gap-5 mt-5 ">
                  <p className=" d-flex align-items-center gap-2 ">
                    <span className="shipping__icon">
                      <i class="ri-car-line"></i>
                    </span>{" "}
                    Gratis Biaya Antar
                  </p>

                  <p className=" d-flex align-items-center gap-2 ">
                    <span className="shipping__icon">
                      <i class="ri-shield-check-line"></i>
                    </span>{" "}
                    100% Aman Terpecaya
                  </p>
                </div>
              </div>
            </Col>

            <Col lg="6" md="6">
              <div className="hero__img">
                <img src={heroImg} alt="hero-img" className="w-100 p-5" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row>
            <Col lg="12" className="text-center">
              <h2>Popular Foods</h2>
            </Col>

            <Col lg="12">
              <div className="food__category d-flex align-items-center justify-content-center gap-4">
                <button
                  className={`all__btn  ${
                    category === "ALL" ? "foodBtnActive" : ""
                  } `}
                  onClick={() => setCategory("ALL")}
                >
                  All
                </button>
                <button
                  className={`d-flex align-items-center gap-2 ${
                    category === "FOOD" ? "foodBtnActive" : ""
                  } `}
                  onClick={() => setCategory("FOOD")}
                >
                  <img src={foodCategoryImg01} alt="" />
                  Food
                </button>

                <button
                  className={`d-flex align-items-center gap-2 ${
                    category === "DRINK" ? "foodBtnActive" : ""
                  } `}
                  onClick={() => setCategory("DRINK")}
                >
                  <img src={foodCategoryImg02} alt="" />
                  Drink
                </button>

                <button
                  className={`d-flex align-items-center gap-2 ${
                    category === "SNACK" ? "foodBtnActive" : ""
                  } `}
                  onClick={() => setCategory("SNACK")}
                >
                  <img src={foodCategoryImg03} alt="" />
                  Snack
                </button>
              </div>
            </Col>

            {allProducts.map((item) => (
              <Col lg="3" md="4" sm="6" xs="6" key={item.id} className="mt-5">
                <ProductCard item={item} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row>
            <Col lg="6" md="6">
              <div className="testimonial ">
                <h5 className="testimonial__subtitle mb-4">Testimoni</h5>
                <h2 className="testimonial__title mb-4">
                  Tanggapan <span>customers</span> Terhadap Kami
                </h2>

                <TestimonialSlider />
              </div>
            </Col>

            <Col lg="6" md="6">
              <img src={networkImg} alt="testimonial-img" className="w-100" />
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Home;
